import { Container } from '@mui/material';
import React from 'react';
import IncomeRadios from '../components/Forms/IncomeRadios';
import Header from '../components/common/Header';
import IntroCard from '../components/Cards/IntroCard';
import '../Style/Theme/index.css';

export default function IncomeProof() {
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={7} />
        <IntroCard
          title="Upload any income proof document"
          subtitle={'Please upload atleast 1 income proof to proceed'}
          img="/assets/doc.svg"
        />
              <IncomeRadios skip={ true} />
      </Container>
    </>
  );
}
